"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToDoToSeeIcon = ToDoToSeeIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ToDoToSeeIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M7.653 4.8L9.3 3H14.7L16.347 4.8H19.2C20.19 4.8 21 5.61 21 6.6V17.4C21 18.39 20.19 19.2 19.2 19.2H4.8C3.81 19.2 3 18.39 3 17.4V6.6C3 5.61 3.81 4.8 4.8 4.8H7.653ZM7.5 12C7.5 14.484 9.516 16.5 12 16.5C14.484 16.5 16.5 14.484 16.5 12C16.5 9.516 14.484 7.5 12 7.5C9.516 7.5 7.5 9.516 7.5 12ZM14.88 12C14.88 13.5906 13.5906 14.88 12 14.88C10.4094 14.88 9.11999 13.5906 9.11999 12C9.11999 10.4095 10.4094 9.12004 12 9.12004C13.5906 9.12004 14.88 10.4095 14.88 12Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}